import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../data/translations';

const QuestionsCTASection = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-white" data-testid="questions-cta-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
          <div className="text-center md:text-left">
            <h2
              className="text-2xl md:text-4xl font-bold text-gray-900"
              data-testid="questions-title"
            >
              {getTranslation(language, 'questionsTitle')}
            </h2>
            <p className="mt-3 text-base md:text-lg text-gray-600">
              {getTranslation(language, 'questionsSubtitle')}
            </p>
          </div>
          <button
            type="button"
            onClick={() => navigate('/votre-projet')}
            className="inline-flex items-center justify-center border-2 border-[#702963] text-[#702963] font-semibold tracking-wide px-8 py-3 hover:bg-[#702963] hover:text-white transition-all duration-300 whitespace-nowrap"
            data-testid="questions-contact-btn"
          >
            {getTranslation(language, 'questionsContactBtn')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default QuestionsCTASection;
